// Gradiente vermelho -> laranja -> verde para representar visualmente o quão
// perto um percentual está de 100%. Usado hoje só no donut de "Progresso do
// edital" (EditalProgressPanel), que é o único gráfico da tela que expressa
// "quanto falta/quanto já foi" e não uma categoria (matéria). Os tons batem
// com --error-color/--accent-color/--success-color de Colors.css em cada tema,
// pra não introduzir uma paleta nova — só interpolar entre as já existentes.
const LIGHT_STOPS = [
  { pct: 0, rgb: [215, 38, 61] },   // --error-color
  { pct: 50, rgb: [232, 128, 47] }, // --accent-color
  { pct: 100, rgb: [47, 191, 113] } // --success-color
];

const DARK_STOPS = [
  { pct: 0, rgb: [239, 107, 115] }, // --error-color
  { pct: 50, rgb: [245, 158, 11] }, // --accent-color
  { pct: 100, rgb: [52, 211, 153] } // --success-color
];

export const getProgressGradientColor = (percent, theme = 'light') => {
  const stops = theme === 'dark' ? DARK_STOPS : LIGHT_STOPS;
  const clamped = Math.max(0, Math.min(100, percent));
  const [from, to] = clamped <= 50 ? [stops[0], stops[1]] : [stops[1], stops[2]];
  const t = (clamped - from.pct) / (to.pct - from.pct);
  const [r, g, b] = from.rgb.map((channel, i) => Math.round(channel + (to.rgb[i] - channel) * t));
  return `rgb(${r}, ${g}, ${b})`;
};
